import React from 'react';

import { useLanguage } from '../i18n';
import Logo from './Logo';

const Footer = () => {
  const { t } = useLanguage();
  const { footer } = t;

  return (
    <footer className='border-t border-line'>
      <div className='container flex flex-col gap-10 py-12 md:flex-row md:items-start md:justify-between'>
        <div className='max-w-[320px]'>
          <Logo />
          <p className='mt-4 leading-relaxed text-muted'>
            {footer.tagline}
            <br />
            {footer.place}
          </p>
        </div>
        <nav aria-label={t.footerNavLabel}>
          <ul className='grid grid-cols-2 gap-x-12 gap-y-1 text-[15px] font-medium text-muted'>
            {t.navigation.map((item) => (
              <li key={item.href}>
                <a className='inline-flex min-h-[44px] items-center transition-colors hover:text-ink' href={item.href}>
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className='container flex flex-col gap-2 border-t border-line py-6 text-sm text-muted sm:flex-row sm:justify-between'>
        <p>© {new Date().getFullYear()} Ronda</p>
        <p>{footer.note}</p>
      </div>
    </footer>
  );
};

export default Footer;
